import type { MaskMode } from './types';

/** Keeps paint mode temporary. Any editor context change returns to Move. */
export class EditorInteractionMode {
  private current: MaskMode = 'off';

  get value(): MaskMode { return this.current; }
  set(value: MaskMode): boolean {
    if (value === this.current) return false;
    this.current = value;
    return true;
  }
  leaveContext(): boolean { return this.set('off'); }
  selectLayer(previousId: string | null, nextId: string | null): boolean {
    return previousId === nextId ? false : this.leaveContext();
  }
}
